import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { appHistory } from 'appHistory';
import { fetchUser } from 'actions/';
import Profile from 'components/fe/HeaderProfile.jsx';
import ReduxSuperUser from 'containers/fe/ReduxSuperUser.jsx';
import ReduxAuthAlert from 'containers/fe/ReduxAuthAlert.jsx';
// import ReduxErrorAlert from 'containers/fe/ReduxErrorAlert.jsx';
import { casURL, baseURL } from 'util/AppConfig.jsx';
// import { decodeText } from 'util/EncodeUtils.jsx';
import { Layout, Menu, Alert, Spin, Icon, ConfigProvider } from 'antd';
import './FrontendApp.scss';
import { menuLink } from 'util/NavigationUtils.jsx';

const { Header, Content, Footer } = Layout;
const authURL = casURL + baseURL;
const customizeRenderEmpty = () => (
  <div style={{ textAlign: 'center' }}>
    <Icon type="frown" style={{ fontSize: 20 }} />
    <p>Nessun dato disponibile</p>
  </div>
);

class FrontendApp extends React.Component {

  componentDidMount() {
    if (!this.props.isLoaded) {
      this.props.fetchUserInfo()
          .then(() => {
            /* console.log('debug fetchUserInfo->then :', window.location.href.split('?ticket='));
             * const urlToClean = window.location.href.split('?ticket=');
             * const pathname = urlToClean[0].split(':3000')[1];
             * console.log('debug pathname : ', pathname);
             * const uri = urlToClean[1].split('#');
             * console.log('debug update url without ticket query param :', uri);
             * // const newUrl = urlToClean[0].concat('/#', uri[1]);
             * const newUrl = pathname.concat('/#', uri[1]);
             * console.log('debug new url :', newUrl);
             * const newhref = appHistory.createHref(newUrl);
             * window.history.replaceState({}, '', newhref);*/
            const newhref = appHistory.createHref(appHistory.getCurrentLocation());
            window.history.replaceState({}, '', newhref);
          })
          .catch((error) => {
            console.log('arrivato al catch', error);
            if (error.error) {
              if (window.location.search.indexOf('ticket=') === -1 &&
                  window.location.hash.indexOf('ticket=') === -1) {
                window.location.href = `${casURL}${encodeURIComponent(window.location.href)}`;
                // setTimeout(window.location.assign(authURL), 2000);
              }
              /* const cookie = document.cookie;
               * console.log('debug 9:', cookie);
               * const idOf = cookie.indexOf('CASTGC');
               * if (!(cookie && idOf > -1)) {
               *   window.location.href = `${casURL}${encodeURIComponent(window.location.href)}`;
               *   // setTimeout(window.location.assign(authURL), 2000);
               *   console.log('errore!', error);
               * }*/
            }
          }
          );
    } else {
      console.log('sono arrivato al controllo di redirect al CAS');
      if (this.props.user.error) {
        window.location.assign(authURL);
      }
    }
  }

  renderChildren = () => {
    if (this.props.isLoaded && this.props.user.nomeCompleto) {
      if (this.props.user.registriUserType === 'A' && !this.props.otherCf) {
        return (
          <Alert
            message="Attenzione"
            description="Impersonificazione utente assente."
            type="warning"
            showIcon
          />);
      }
      return this.props.children;
    }

    return (
      <div>
        <Spin
          spinning
          tip="Caricamento..."
        />
      </div>
    );
  }

  render() {
    console.log('accesso con utente:', this.props.user);
    console.log('otherCF:', this.props.otherCf);

    const isSuperUser = (this.props.user && this.props.user.registriUserType === 'A' ? true : false);
    return (
      <Layout className="layout" style={{ background: '#ecf0f5', height: '100%' }}>
        <Header className="unimi-header">
          <div className="logo" />
          <Menu
            theme="dark"
            mode="horizontal"
            style={{ lineHeight: '64px' }}
            selectable={false}
            onClick={menuLink}
          >
            { isSuperUser === true && 
              <Menu.Item key="user">
                <ReduxSuperUser />
              </Menu.Item>
            }
            <Menu.Item key="faq">
              <Icon type="question-circle" />
              FAQ
            </Menu.Item>
            <Menu.Item key="home">
              <Icon type="home" />
              HOME
            </Menu.Item>
            <Menu.Item key="logout">
              <Icon type="logout" />
              LOGOUT
            </Menu.Item>
            <Menu.Item className="no-link">
              <Profile user={this.props.user} embodies={this.props.otherCf} />
            </Menu.Item>
          </Menu>
        </Header>
        <Content className="unimi-content-body">
          <ConfigProvider renderEmpty={customizeRenderEmpty}>
            <div>{this.renderChildren()}</div>
          </ConfigProvider>
        </Content>
        <Footer className="unimi-footer">
          <b>Copyright ©2019 Ufficio Integrazione Sviluppo,
            Direzione Sistemi Informativi UniMI
          </b> - Tutti i diritti riservati.
        </Footer>
        <ReduxAuthAlert />
      </Layout>
    );
  }
} 

FrontendApp.propTypes = {
  children: PropTypes.node,
  user: PropTypes.object,
  otherCf: PropTypes.string,
  isLoaded: PropTypes.bool,
  fetchUserInfo: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.userInfo.data,
  otherCf: state.userInfo.otherCF,
  isLoaded: state.userInfo.isLoaded,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUserInfo: () => dispatch(fetchUser()),
});

const ReduxFrontendApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(FrontendApp);

export default ReduxFrontendApp;

